
export default {
    install: (app, options) => {
        // 获取参数
        
        app.config.globalProperties.$globalUrl = window.location.origin

        
        app.config.globalProperties.$getParameterByName = (name) => {
            let url = window.location.href;
            name = name.replace(/[[]]/g, '\\$&');
            let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
                results = regex.exec(url);
            if (!results) {
              return null;
            }
            if (!results[2]) {
              return '';
            }
            return decodeURIComponent(results[2].replace(/\+/g, ' '));
        }
          
        // 获取图片
        app.config.globalProperties.$getImg = (name) => {
            return new URL(`../assets/image/${name}.png`, import.meta.url).href
        }

        // 随机字符串
        app.config.globalProperties.$generateRandomString = (length) => {
            let result = ''
            let characters = 'abcdefghijklmnopqrstuvwxyz0123456789'
            for(let i = 0; i < length; i++) {
                let randomIndex = Math.floor(Math.random() * characters.length)
                result += characters.charAt(randomIndex) 
            }
            return result
        }

        // 下载
        app.config.globalProperties.$downurl = (url, domain) => {
            console.log(`开始下载: ${url}`);
            const a = document.createElement('a');
            a.href = url + '?channelCode=' + domain;
            a.download = ''; // 可选：设置下载文件名
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        }

        // 自定义模板
        app.config.globalProperties.$downloadBtn = async (templateData) => {
            
            let {collection_down_link,android_down_link,ios_down_link, domain} = templateData

            if(collection_down_link && collection_down_link != '') {  // 使用集合地址
                console.log('合集地址')
                app.config.globalProperties.$downurl(collection_down_link, domain)
            } else {
                console.log('判断是安卓还是ios 下载对应')
                // 判断是安卓还是ios 下载对应的
                const userAgent = navigator.userAgent || navigator.vendor || window.opera;
                console.log('userAgent', userAgent)
                if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                    console.log('ios')
                    if(ios_down_link && ios_down_link != '') {
                        
                        app.config.globalProperties.$downurl(ios_down_link, domain)
                    }
                } else if (/android/i.test(userAgent)) {
                    console.log('安卓')
                    if(android_down_link && android_down_link != '') {
                        
                        app.config.globalProperties.$downurl(android_down_link)
                    }
                } else {
                    if(android_down_link && android_down_link != '') {
                        console.log('PC')
                        app.config.globalProperties.$downurl(android_down_link)
                    }
                }
            }
        }

        // 获取模板
        app.config.globalProperties.$defaultinitialization = async (templateData, refElement) => {
            refElement.value.onclick = function() {
                app.config.globalProperties.$downloadBtn(templateData)
            };
        }



        // 加载统计代码
        app.config.globalProperties.$insertScripts = async (templateData) => {
            const container = document.createElement('div');
            container.innerHTML = templateData.statistical_code;
            // 查找所有嵌入的脚本
            const scripts = container.querySelectorAll('script');
            const externalScripts = [];
            const inlineScripts = [];

            scripts.forEach(script => {
                if (script.src) {
                  externalScripts.push(script);
                } else {
                  inlineScripts.push(script);
                }
            });

            // 加载外部脚本
            const loadExternalScripts = externalScripts.map(script => {
                return new Promise((resolve, reject) => {
                const newScript = document.createElement('script');
                newScript.src = script.src;
                newScript.id = script.id;
                newScript.onload = resolve;
                newScript.onerror = reject;
                    document.body.appendChild(newScript);
                });
            });

            Promise.all(loadExternalScripts).then(() => {
                // 执行内联脚本
                inlineScripts.forEach(script => {
                    const newScript = document.createElement('script');
                    newScript.textContent = script.textContent;
                    document.body.appendChild(newScript);
                });
            }).catch(error => {
                console.error('Error loading external scripts:', error);
            });
        }



        // 集成商merchant
        app.config.globalProperties.$initialization = async (templateData, refElement) => {
            let {merchant, app_key, domain, appinstall_server} = templateData
            console.log('加载集成商模板', merchant)
            
            const merchantMap = {
                'aigpt': { path: () => import('@/plugins/js/aigpt.js'), className: 'AIgpt', method: 'wakeupOrInstall' },
                'appinstall': { path: () => import('@/plugins/js/appinstall.js'), className: 'AppInstall', method: 'install'},
                'openinstall': { path: () => import('https://res.openinstall.com/openinstall-sxwksd.js'), className: 'OpenInstall', method: 'wakeupOrInstall'},
                'openshare': { path: () => import('@/plugins/js/openshare.js'), className: 'OpenShare', method: 'wakeupOrInstall'},
            };

            const loadModule = async (merchantConfig) => {
                const {path, className} = merchantConfig
                try {
                    let MerchantClass = null
                    let data = null
                    if(className === 'OpenShare') {
                        let script = document.createElement('script');
                        script.src = 'https://os.sdwok.cn/open/os2.js';
                        script.async = false;
                        document.head.appendChild(script);
                        script.onload = async () => {
                            // let {app_key} = merchantConfig
                            // 在脚本加载完成后执行的操作

                            let m = new window.OpenShare({ appKey: app_key });

                            refElement.value.onclick = function(event) {
                                event.stopPropagation(); // 防止事件冒泡
                                event.preventDefault(); // 阻止默认行为
                                console.log(m)
                                m.wakeupOrInstall;
                            };
                        };
                    } else {
                        await path()
                        if(className === 'AIgpt') {
                            data = AIgpt.parseUrlParams();
                            MerchantClass = AIgpt
                        } else if (className === 'AppInstall') {
                            data = AppInstall.parseUrlParams();
                            MerchantClass = AppInstall
                        } else if (className === 'OpenInstall') {
                            data = OpenInstall.parseUrlParams();
                            MerchantClass = OpenInstall
                        }
                    }
                    return {MerchantClass, data};
                } catch (error) {
                    console.error(`找不到模板 :`, error);
                    throw error;
                }
            };

            const initializeMerchant = async (merchantConfig) => {
                const { method,className } = merchantConfig;
                const regex = /^(?!www\.)([a-z0-9]+)\.([a-z0-9\-]+\.[a-z]{2,})(:\d+)?$/i;
                let server = null
                if(className === 'AppInstall') {
                    // appinstall_server  接口 1级
                    //  wisdomcounty.com:6443  默认
                    let url = 'wisdomcounty.com:6443 '
                    if(appinstall_server && appinstall_server !== '') {
                        url = appinstall_server
                    }
                    if(regex.test(url)) {
                        server = 'https://' + url
                    }else {
                        server = 'https://' + app.config.globalProperties.$generateRandomString(15) + '.'+ url
                    }
                    
                }

                if(className === 'OpenShare') {
                    await loadModule(merchantConfig);

                } else {
                    let {MerchantClass, data} = await loadModule(merchantConfig);
                    new MerchantClass({
                        appKey: app_key,
                        channelCode: domain,
                        server: server,
                        onready: function() {
                            const m = this;
                            refElement.value.onclick = function(event) {
                                event.stopPropagation(); // 防止事件冒泡
                                event.preventDefault(); // 阻止默认行为
                                m[method]();
                                return false;
                            };
                        }
                    }, data);
                }
            };

            const merchantConfig = merchantMap[merchant];

            if (merchantConfig) {
                await initializeMerchant(merchantConfig);
            } else {
                console.error('Unsupported merchant:', merchant);
            }
        }

        // 落地页跳转H5
        app.config.globalProperties.$goVisitClick = (item, templateData) => {
            let {url} = item
            if (!url.match(/^http(s)?:\/\//i)) {
                // 如果没有协议，添加 http://
                url = 'http://' + url;
            }
            let str = app.config.globalProperties.$getParameterByName('shareName')
            if(str && str != '') {
                window.open(`${url}${window.location.search}`, '_blank');
            } else {
                window.open(`${url}?channelCode=${item.domain}`, '_blank');
            }
        }

        // 落地页跳转客服
        app.config.globalProperties.$customerClick = (templateData) => {
            if(templateData.customer_link !== '') {
                window.open(templateData.customer_link, '_blank');
            }
            
        }

        // 跳转飞机
        app.config.globalProperties.$telegram_linkClick = (templateData) => {
            if(templateData.telegram_link !== '') {
                window.open(templateData.telegram_link, '_blank');
            }
        }
        // 自定义连接
        app.config.globalProperties.$customize_linkClick = (url) => {
            if(url !== '') {
                window.open(url, '_blank');
            }
        }

        // 倒计时
        app.config.globalProperties.$startCountdown = ({str, time=60,value='重新获取', callback}) => {
            let num = time;
            str.value = time + 's';
            let countdownTimer = setInterval(() => {
                num--;
                str.value = num + 's';
                if (num <= 0) {
                    clearInterval(countdownTimer);
                    str.value = value;
                    if (callback) callback();
                }
            }, 1000);
        };

        // 获取时间
        app.config.globalProperties.$getTimeRange = (offset = 1) => {
            // 获取当前时间
            const now = new Date();
            // 初始化开始时间和结束时间
            let startTime, endTime;
            if (offset === 0) {
                // 昨天的开始时间和结束时间
                const yesterday = new Date(now);
                yesterday.setDate(now.getDate() - 1);
                const year = yesterday.getFullYear();
                const month = String(yesterday.getMonth() + 1).padStart(2, '0');
                const day = String(yesterday.getDate()).padStart(2, '0');
                startTime = `${year}-${month}-${day} 00:00:00`;
                endTime = `${year}-${month}-${day} 23:59:59`;
            } else {
                // 计算开始时间
                const startDate = new Date(now);
                startDate.setDate(now.getDate() - (offset - 1));
                const startYear = startDate.getFullYear();
                const startMonth = String(startDate.getMonth() + 1).padStart(2, '0');
                const startDay = String(startDate.getDate()).padStart(2, '0');
                startTime = `${startYear}-${startMonth}-${startDay} 00:00:00`;

                // 当前时间作为结束时间
                const endYear = now.getFullYear();
                const endMonth = String(now.getMonth() + 1).padStart(2, '0');
                const endDay = String(now.getDate()).padStart(2, '0');
                const endHour = String(now.getHours()).padStart(2, '0');
                const endMinute = String(now.getMinutes()).padStart(2, '0');
                const endSecond = String(now.getSeconds()).padStart(2, '0');
                endTime = `${endYear}-${endMonth}-${endDay} ${endHour}:${endMinute}:${endSecond}`;
            }
            return [startTime, endTime];
        }
    }
}